/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import styled from 'styled-components';
import Icon from '@mui/icons-material/ExpandLess';
import Config from 'Config';

export const ExpandLessIcon = styled(Icon)`
    font-size: 20px !important;
    color: ${Config.color.localGray};
`;
